import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import type CSVHeaderColumn from '../../types/CSVHeaderColumn';
import type CSVRow from '../../types/CSVRow';
import MatchHeadersTableRow from './MatchHeadersTableRow';

export type MatchHeadersTableProps = {
  headers: CSVHeaderColumn[];
  rows: CSVRow[];
};

export default function MatchHeadersTable({
  headers,
  rows,
}: MatchHeadersTableProps) {
  return (
    <TableContainer>
      <Table className="table-fixed border-separate border-spacing-[1px] bg-grey-600">
        {/*
          Use col tags (along with colSpan on the first table cell) to 
          set min width for first row .
        */}
        <colgroup>
          <col className="min-w-[300px]" />
          <col />
          <col />
          <col className="min-w-[200px]" />
        </colgroup>

        <TableBody>
          {headers.map((header, index) => (
            <MatchHeadersTableRow
              header={header}
              index={index}
              key={header.id}
              rows={rows}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
